module.exports = "<growl-notifications></growl-notifications>\n\n<div ng-repeat=\"message in $ctrl.messages track by message.id\">\n    <growl-notification ng-class=\"{ok: message.ok, error: message.error}\">\n        {{message.text}}\n    </growl-notification>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/notifications/notifications.html
// module id = 44
// module chunks = 0